import React from "react";
import { Box, Typography } from "@material-ui/core";
import successLogo from "assets/icons/eventSuccessfull.svg";
import MyButton from "components/MyButton";

const NewTaskSuccess = ({ taskCloseModal }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{ pt: 7 }}
    >
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <img src={successLogo} alt="Success" />
        <Typography
          variant="h2"
          className="assign-successful-h"
          style={{
            marginTop: 16,
            marginBottom: 40,
            color: "#2555ef",
            fontSize: 24,
          }}
        >
          Task successfully created
        </Typography>
      </Box>

      <Box display="flex" justifyContent="center" width="100%">
        <Box className="task-success-btn">
          <MyButton
            type="primary"
            content="Close"
            onClick={taskCloseModal}
            style={{ width: 150, marginTop: 130, marginBottom: 30 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NewTaskSuccess;
